import instructionalPart2Description from '../content/instructionalPart2';

import { unemployabilityTitle } from '../content/unemployabilityFormIntro';

export const uiSchema = {
  'ui:title': unemployabilityTitle,
  'ui:description': instructionalPart2Description,
};

export const schema = {
  type: 'object',
  properties: {},
};
